module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11WoIRV/tc-custom/9781526726612.jpg?1729379497847",
      "alt": "This image is the cover for the book Railways and Industry in the Tondu Valleys, South Wales Valleys"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Railways and Industry in the Tondu Valleys, South Wales Valleys\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A photo-filled history of this part of Welsh coal country and its freight and passenger service.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Following the first volume dealing with the Llynfi Valley, this book provides details on individual aspects of railways operation focusing on the Ogmore, Garw, and Porthcawl branches in this area of South Wales. The books give a history of the railway, coal mining, and other industrial aspects of each Valley that combine to make up the Tondu Valleys, with detailed comments on the operation of the railway, passenger and freight, and details of each colliery within the area and their place within the South Wales coalfield. The study of Porthcawl traces its development from a dock to a seaside resort with supporting photographs of both aspects. Each location is studied in detail with abundant photographs of railway and colliery activity. This is the first time such a study of this area has been undertaken in such detail.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Hodge, Stuart Davies\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0